<template>
  <div>
    <form class="sc-user-input">
      <div role="button" tabindex="0" contenteditable="true" class="sc-user-input--text"
           ref="userInput" :placeholder="placeholder" @keydown="handleKey"></div>
      <div class="sc-user-input--buttons">
        <div class="sc-user-input--button">
          <v-icon :size="20" class="grey--text"
                  @click="emojiPickerDialog = true">far fa-smile</v-icon>
        </div>
        <div class="sc-user-input--button">
          <v-icon class="teal--text" :size="25" @click="submitText">send</v-icon>
        </div>
      </div>
    </form>

    <v-dialog v-model="emojiPickerDialog" :max-width="338">
      <v-card>
        <Picker @select="addEmojiToUserInput" set="google" :sheetSize="32"/>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Picker } from 'emoji-mart-vue';

export default {
  name: 'UserInput2',
  components: { Picker },
  props: {
    onSubmit: { type: Function, required: true },
    showEmoji: { type: Boolean, default: false },
    showFile: { type: Boolean, default: false },
    placeholder: { type: String, default: 'Write a reply' },
  },
  data() {
    return {
      file: null,
      emojiPickerDialog: false,
    };
  },
  methods: {
    handleKey(event) {
      console.log(event.code)
      if (event.code === 'Enter' && !event.shiftKey) {
        this.submitText();
        event.preventDefault();
      }
    },
    submitText() {
      const text = this.$refs.userInput.innerHTML;
      this.onSubmit({ type: 'text', data: text });
      this.file = null;
      this.$refs.userInput.textContent = '';
    },
    addEmojiToUserInput(emoji) {
      this.onSubmit({ type: 'emoji', data: emoji.colons });
      this.emojiPickerDialog = false;
    },
  },
};
</script>

<style>
  /*User Input*/
  .sc-user-input {
    min-height: 55px;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    border-top: solid medium #009688;
    background-color: white;
  }
  .sc-user-input--text {
    width: 80%;
    resize: none;
    border: none;
    outline: none;
    border-bottom-left-radius: 10px;
    box-sizing: border-box;
    padding: 18px;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.33;
    white-space: pre-wrap;
    word-wrap: break-word;
    color: #565867;
    -webkit-font-smoothing: antialiased;
    max-height: 200px;
    overflow: scroll;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .sc-user-input--text:empty:before {
    content: attr(placeholder);
    display: block; /* For Firefox */
    /* color: rgba(86, 88, 103, 0.3); */
    filter: contrast(15%);
    outline: none;
  }
  .sc-user-input--buttons {
    position: absolute;
    right: 30px;
    height: 100%;
    display: flex;
  }
  .sc-user-input--button {
    width: 30px;
    height: 55px;
    margin-left: 2px;
    margin-right: 2px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .sc-user-input--button label {
    position: relative;
    height: 24px;
    padding-left: 3px;
    cursor: pointer;
  }
  .sc-user-input--button label:hover path {
    fill: rgba(86, 88, 103, 1);
  }
  .sc-user-input--button input {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 99999;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    overflow: hidden;
  }
</style>
